import $ from "jquery";
import PubSub from "pubsub-js";
import ResponsiveHelper from "utils/responsive_helper";
import RangeSlider from "components/range_slider";
import ProductListFilterController from "components/product_list/product_list_filter_controls";
import ResponsiveProductBoxController from "components/product_list/responsive_product_box";
import 'utils/lazyload.js'
import {fixAjaxSwiperImages} from "utils/lazyload";
import ProductListPaging from "components/product_list/product_list_paging";

export default function ProductListFilters() {
  PubSub.subscribe("core.preattach", this.preAttach.bind(this));
  PubSub.subscribe("core.attach", this.attach.bind(this));
  this.attach("init", this);
  this.in_ids = [];
  this.responsiveHelper = new ResponsiveHelper();
  this.rangeSlider = new RangeSlider();
  this.rangeSlider.init();

  this.hideTeasersIfFilterActive();
  const _this = this;
  $(document).ajaxComplete(function () {
    _this.hideTeasersIfFilterActive();
  });
}


ProductListFilters.prototype.preAttach = function (msg, element) {
  this.rangeSlider.init();
  this.in_ids.forEach(function (id) {
    element.find(".product-filter-list #" + id).removeClass("collapse").addClass("in");
  });
};

ProductListFilters.prototype.attach = function (msg, element) {
  const _this = this;

  reloadUrl = reloadUrl.bind(_this);

  $("#from_price, #to_price").on("click", function () {
    $("input[value=range]").attr("checked", "checked");
  });

  $(".colorThumb").tooltip();

  $("form#filter-form input.js-slider-filter-input").off("slideStop", reloadFilter).on("slideStop", reloadFilter);
  $("form#filter-form input[type='checkbox']").off("change", reloadFilter).on("change", reloadFilter);
  $("#product-filter-dropdown").off("change", reloadSort).on("change", reloadSort);
  $("form#filter-form .filter-reset, .js-reset-all-filters", element).off("click").on("click", resetAllFilters);

  // Reset a single filter
  $(".js-filter-reset", element).off("click").on("click", resetFilter);

  // Displays the selected filter inside a wrapper only if at-least one filter is selected
  const $filterWrapper = $(".product-filter-bar-wrapper--hidden");
  if ($filterWrapper.children().length > 1) {
    $filterWrapper.addClass("product-filter-bar-wrapper--show");
  }

  const bs_events = "shown.bs.collapse hidden.bs.collapse";
  $(".product-filter-controls").off(bs_events).on(bs_events, function () {
    _this.in_ids = []; //save open accordion tabs
    $(".product-filter-list .in").each(function () {
      _this.in_ids.push($(this).attr("id"));
    });
  });
};

function reloadSort($event) {
  let url = new URL(window.location);
  const sortBy = $event.target.value;
  if (sortBy === undefined) {
    url.searchParams.delete("sortBy");
  } else {
    url.searchParams.set("sortBy", sortBy);
  }

  reloadUrl(url);
}

function reloadFilter($event) {
  let url = new URL(window.location);
  url.searchParams.set("show", "all");

  const target = $event.target;

  const filterName = target.name;
  const filterValue = target.value;
  const type = target.type;

  if (type === "checkbox") {
    if (target.checked) {
      url.searchParams.append(filterName, filterValue);
    } else {
      let newParams = [];
      let allRelevantParams = url.searchParams.getAll(filterName);
      url.searchParams.delete(filterName);
      allRelevantParams.forEach(function (element) {
        if (element !== filterValue) {
          newParams.push(element);
        }
      })
      newParams.forEach(function (element) {
        url.searchParams.append(filterName, element);
      })
    }
  } else {
    const sliderMin = target.dataset.sliderMin;
    const sliderMax = target.dataset.sliderMax;

    if (filterValue !== undefined && filterValue !== sliderMin + "," + sliderMax) {
      url.searchParams.set(filterName, filterValue);
    } else {
      url.searchParams.delete(filterName);
    }
  }

  reloadUrl(url);
}

function resetFilter($event) {
  const target = $event.target;
  if (target !== undefined) {
    const resetElem = target.closest(".js-filter-reset");
    let url = new URL(window.location);
    url.searchParams.set("show", "all");

    const filterName = resetElem.dataset.inputName;
    const filterValue = resetElem.dataset.inputValue;

    if (filterValue === undefined) {
      url.searchParams.delete(filterName);
    } else {
      let allRelevantParams = url.searchParams.getAll(filterName);
      url.searchParams.delete(filterName);
      if (allRelevantParams.length > 1) {
        let newParams = [];
        allRelevantParams.forEach(function (element) {
          if (element !== filterValue) {
            newParams.push(element);
          }
        })
        newParams.forEach(function (element) {
          url.searchParams.append(filterName, element);
        })
      }
    }

    reloadUrl(url);
  }
}

function resetAllFilters($event) {
  let url = new URL(window.location);
  $(".js-filter-reset").each(function () {
    url.searchParams.delete($(this).data("input-name"));
  })
  reloadUrl(url);
}

function reloadUrl(url) {
  const _this = this;

  const filterLayerStatus = {};

  $(".js-activate-filter-layer").each(function () {
    $.each(this.attributes, function () {
      if (this.specified) {
        filterLayerStatus[this.name] = this.value;
      }
    });
  });

  $.ajax({
    cache: false,
    url: url,
  }).done(function (data) {
    const $data = $(data).find("#productListProductsAndFilters").detach();

    if ($data.length === 0) {
      window.location.reload();
      return;
    }

    PubSub.publish("core.preattach", $data);

    const $content = $("#productListProductsAndFilters");

    $content.replaceWith($data);

    window.history.pushState({}, document.title, url);

    PubSub.publishSync("core.attach", $data);

    _this.responsiveHelper.republishResizeEvent();

    if (_this.filtersAreActive()) {
      $("html, body").animate(
          {scrollTop: $content.offset().top},
          300
      );
    }

    fixAjaxSwiperImages($(".js-product-list-update-images").find("img[data-src]"));

    _this.reEnableJSFunctionalityAfterAjax({
      ProductListFilterController: filterLayerStatus,
    });

    const $productFilter = $(".product-filter__filter");
    const productFilterActive = "product-filter__filter--active";

    $productFilter.removeClass(productFilterActive);
  });
}

ProductListFilters.prototype.reEnableJSFunctionalityAfterAjax = function (params) {
  new ProductListFilterController().init(params.ProductListFilterController);
  new ResponsiveProductBoxController().init();
  new ProductListPaging().init();
  if ($(".video-play-button").length !== 0) import('../../libs/youtube.js').then(YoutubePlayer => (new YoutubePlayer.default()));
  if ($(".mobile-service-cta").length !== 0) import('../utils/sticky_mobile_service_helper').then(StickyMobileServiceHelper => (new StickyMobileServiceHelper.default()).init());
}

ProductListFilters.prototype.toggleLoadingSpinner = function () {
  $(".js-active-filter-spinner").removeClass("product-filter__loading--hidden");
}

ProductListFilters.prototype.showTeasersIfNotOffCanvas = function () {
  if (!$("body").hasClass("offcanvas")) {
    this.showTeasers();
  } else {
    this.hideTeasers();
  }
}

ProductListFilters.prototype.hideTeasersIfFilterActive = function () {
  if (this.filtersAreActive() || this.isPsmAds()) {
    this.hideTeasers();
  } else {
    this.showTeasersIfNotOffCanvas();
  }
}

ProductListFilters.prototype.filtersAreActive = function () {
  const checkboxes = $(".eClick");
  let checked = false;
  for (let i = 0, n = checkboxes.length; i < n; i++) {
    if (checkboxes[i].checked) {
      checked = true;
      break;
    }
  }
  return checked || this.sliderChanged();
}

ProductListFilters.prototype.sliderChanged = function () {
  let sliderHasChanged = false;

  $(".product-filter-list .slider .eClick, .js-slider-filter-input").each(function () {
    const sliderMin = $(this).data("slider-min");
    const sliderMax = $(this).data("slider-max");
    const sliderValue = $(this).data("slider-value");
    const changed = sliderValue[0] !== sliderMin || sliderValue[1] !== sliderMax;
    sliderHasChanged = sliderHasChanged || changed;
  });

  return sliderHasChanged;
}

ProductListFilters.prototype.isPsmAds = function () {
  return $("#listing-ads").length > 0;
}

ProductListFilters.prototype.hideTeasers = function () {
  $(".js_hide-when-filter-active").addClass("hidden");
}

ProductListFilters.prototype.showTeasers = function () {
  $(".js_hide-when-filter-active").removeClass("hidden");
}
